import React from 'react'

import { createCodeSource } from '../../codemapping/createCodeSource';
import { quickSortSource } from '../../codemapping/codesources/quickSortSource';

import styled from "styled-components";

const StyledLinesContainer = styled.ul`
  /* background: lightblue; */
  list-style: none;
  overflow: hidden;
  font-family: 'Consolas', 'Courier New', Courier, monospace
`;

interface StyledLineProps {
  Highlight: boolean;
}

const StyledLine = styled.li<StyledLineProps>`
  /* background: lightblue; */
  float: none;
  background: ${props => props.Highlight ? 'lightblue' : 'white'}
`;

let lines : Array<string> = createCodeSource(quickSortSource);

interface CodelinesProps {
  Highlighted?: number | undefined;
}

export function QuickSortCodelines ({ Highlighted } : CodelinesProps )  {
  return (
    <pre>
      HighLighted: {Highlighted}
      <StyledLinesContainer>
        {lines.map((l, i) => {
          return (
            <StyledLine key={i} Highlight={i === Highlighted ? true : false}>{i} : {l}</StyledLine>
          )
        })}
      </StyledLinesContainer>
    </pre>
  )
}
